function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Component from './components/DecisionTablePropertiesComponent';
var LOW_PRIORITY = 500;

var DecisionTableProperties = /*#__PURE__*/_createClass(function DecisionTableProperties(components) {
  _classCallCheck(this, DecisionTableProperties);

  components.onGetComponent('table.before', LOW_PRIORITY, function () {
    return Component;
  });
});

export { DecisionTableProperties as default };
DecisionTableProperties.$inject = ['components'];
//# sourceMappingURL=DecisionTableProperties.js.map